export default "__VITE_ASSET__CaAPE33H__"